import { CanceledError } from 'axios';
import { Dispatch, SetStateAction } from 'react';
import http from '../shared/HttpCommon';

export interface IAiSearchScheduleQuestion {
  country: string;
  query: string;
}

const getMonitoring = async (loading: Dispatch<SetStateAction<boolean>>, signal: AbortSignal) => {
  try {
    loading(true);
    const { data } = await http.get('/ai-search', { signal });
    loading(false);
    return data;
  } catch (error) {
    if (!(error instanceof CanceledError)) {
      loading(false);
      console.error(error);
    }
  }
};

const startMonitoring = async (
  questions: IAiSearchScheduleQuestion[],
  loading: Dispatch<SetStateAction<boolean>>
) => {
  try {
    loading(true);
    const { data } = await http.post('/ai-search/schedule', { questions });
    loading(false);
    return data;
  } catch (error) {
    loading(false);
    console.error(error);
  }
};

const deleteMonitoredAiSearch = async (id: string) => {
  try {
    const { data } = await http.delete(`/ai-search/${id}`);
    return data;
  } catch (error) {
    console.error(error);
  }
};

const AiSearchMonitoringService = {
  getMonitoring,
  startMonitoring,
  deleteMonitoredAiSearch,
};

export default AiSearchMonitoringService;
